import React from "react";
import { ArrowRight } from "lucide-react";
import "../sass/landing/hero.scss";
import Shot from "./landing/Shot";
import { IMAGES } from "./landing/images";
import { scrollToSection } from "./landing/scroll";

const Hero = () => (
  <section id="hero" className="lp-hero" aria-labelledby="hero-title">
    <div className="lp-shell lp-hero__grid">
      <h1 id="hero-title" className="lp-hero__title">
        <span className="lp-hero__title-lead">Você atende.</span>
        <span className="lp-hero__title-rest">
          O PsyAssist cuida da rotina ao redor.
        </span>
      </h1>

      <div className="lp-hero__aside">
        <p className="lp-hero__lead">
          Agenda, confirmações, cobranças, registros e financeiro funcionando
          juntos, para você ter menos tarefas administrativas na cabeça. Nasceu
          da rotina real de uma psicóloga.
        </p>

        <div className="lp-hero__actions">
          <button
            type="button"
            className="lp-button lp-button--primary lp-hero__primary"
            onClick={() => scrollToSection("planos")}
          >
            Começar meus 7 dias grátis
            <ArrowRight size={18} aria-hidden="true" />
          </button>
          <button
            type="button"
            className="lp-link lp-hero__secondary"
            onClick={() => scrollToSection("como-funciona")}
          >
            Ver como funciona no dia a dia
          </button>
        </div>

        <p className="lp-hero__trial">
          7 dias grátis. O cartão é pedido no cadastro e a cobrança só começa
          depois do teste.
        </p>
      </div>
    </div>

    <figure className="lp-hero__figure">
      <div className="lp-shell">
        <figcaption className="lp-hero__stamp">
          <span className="lp-hero__time">08:10</span>
          <span className="lp-hero__rule" aria-hidden="true" />
          <span className="lp-hero__stamp-text">
            Terça-feira, antes do primeiro atendimento.
          </span>
        </figcaption>
      </div>

      <div className="lp-hero__screen">
        <div className="lp-hero__screen-reveal">
          <Shot
            className="lp-frame lp-zoom lp-hero__zoom"
            image={IMAGES.rotinaHoje}
            ui
            eager
            sizes="(min-width: 1024px) 1100px, (min-width: 720px) 100vw, 230vw"
            alt="Tela inicial do PsyAssist com a rotina do dia: próximo atendimento às 08:30 e a lista de sessões, com as confirmações dos pacientes."
          />
        </div>
      </div>

      <div className="lp-shell">
        <p className="lp-caption lp-hero__caption">
          Tela real do PsyAssist. Nomes e horários são de demonstração.
        </p>
      </div>
    </figure>
  </section>
);

export default Hero;
